export const RESOURCE_TYPE_DASHBOARD = 'homepage';
export const RESOURCE_TYPE_ENERGY_COMMUNITY = 'myData';

export default {
  RESOURCE_TYPE_DASHBOARD,
  RESOURCE_TYPE_ENERGY_COMMUNITY,
};
